import React from 'react';

export const Document = ({ id, text }) => {
    return (
        <a className="dark roboto-regular" href={ id } target="_blank" rel="noreferrer">{text}</a>
    );
};

Document.displayName = 'Document';